import type { Map as LeafletMap } from 'leaflet'
import { boundsFromLeaflet, fromLeaflet } from '@/shared/lib'
import type { MapAdapterEntity, MapBounds, MapCoordinates, MapLocation } from './types.ts'

type CreateLeafletAdapterResult = {
  entity: MapAdapterEntity
  syncFromMap: () => void
}

/**
 * Адаптирует Leaflet map к общему контракту inventory-карты.
 * Хранит состояние в формате бизнес-логики `[lng, lat]`.
 */
export const createLeafletAdapter = (leafletMap: LeafletMap): CreateLeafletAdapterResult => {
  let center = fromLeaflet(leafletMap.getCenter()) as MapCoordinates
  let zoom = leafletMap.getZoom()
  let bounds = boundsFromLeaflet(leafletMap.getBounds()) as MapBounds
  let behaviors = ['drag']

  const syncFromMap = () => {
    center = fromLeaflet(leafletMap.getCenter()) as MapCoordinates
    zoom = leafletMap.getZoom()
    bounds = boundsFromLeaflet(leafletMap.getBounds()) as MapBounds
  }

  const entity: MapAdapterEntity = {
    get center() {
      return center
    },
    get zoom() {
      return zoom
    },
    get bounds() {
      return bounds
    },
    get behaviors() {
      return behaviors
    },
    setLocation(location: MapLocation) {
      const nextCenter = location.center ?? center
      const nextZoom = location.zoom ?? zoom

      leafletMap.setView([nextCenter[1], nextCenter[0]], nextZoom)
      syncFromMap()
    },
    getBounds() {
      return bounds
    },
    setBehaviors(next: string[]) {
      behaviors = [...next]
      leafletMap.scrollWheelZoom.enable()

      if (behaviors.includes('drag')) {
        leafletMap.dragging.enable()
      } else {
        leafletMap.dragging.disable()
      }
    },
  }

  return {
    entity,
    syncFromMap,
  }
}
